import * as React from 'react';
import { cva, VariantProps } from 'class-variance-authority';

import { cn } from '../../utils/cn';

const dialogFooterVariants = cva('rocco-dialog-footer', {
    variants: {
        variant: {
            default:
                'flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2',
        },
    },
    defaultVariants: {
        variant: 'default',
    },
});

export const DialogFooter = ({
    className,
    variant,
    ...props
}: React.HTMLAttributes<HTMLDivElement> &
    VariantProps<typeof dialogFooterVariants>) => (
    <div
        className={cn(dialogFooterVariants({ variant, className }))}
        {...props}
    />
);

DialogFooter.displayName = 'DialogFooter';
